import moment from 'moment/moment';

import { storeLocalTime } from './store-time/store-time-utils';
import {
  RESERVATION_BUFFERS,
  AVERAGE_HOURS_GAP_RENTAL_TO_STORE,
  CHRISTMAS_DATES,
  THANKSGIVING_DATES
} from '../constants/constants';
import helper from './helper';

const DATE_FORMAT = 'm/d/Y';
const BASE_OPTS = {
  dateFormat: DATE_FORMAT,
  disable: [...CHRISTMAS_DATES, ...THANKSGIVING_DATES],
  monthSelectorType: 'static',
  yearSelectorType: 'static'
};

const incrementDate = (date, increment) => {
  let newDate = moment(date, 'MM/DD/YYYY').add(increment, 'days');
  return newDate.format('MM/DD/YYYY');
};

const convertToLatestReservationHour = (storeHour) => {
  const timeConversionDict = {
    reservationBuffer: RESERVATION_BUFFERS.pickTime,
    storeClosingBuffer: RESERVATION_BUFFERS.beforeClose,
    hoursGap: AVERAGE_HOURS_GAP_RENTAL_TO_STORE
  };
  const hourBuffer = timeConversionDict.reservationBuffer
    + timeConversionDict.storeClosingBuffer
    + timeConversionDict.hoursGap;

  return storeHour - hourBuffer;
};

const getOptions = (locNbr, hour, firstAvailableDropoffDate) => {
  const LATEST_RES_HOUR = convertToLatestReservationHour(hour);
  const currentTimeAtStore = storeLocalTime(locNbr);
  let currentDate;
  let minDate;
  let maxDate;

  if (
    (currentTimeAtStore.getHours() < LATEST_RES_HOUR)
    || (currentTimeAtStore.getHours() === LATEST_RES_HOUR && currentTimeAtStore.getMinutes() <= 27)
  ) {
    currentDate = incrementDate(currentTimeAtStore.toLocaleDateString('en-US'), 0);
  } else {
    // reservations have to be made day tomorrow
    currentDate = incrementDate(currentTimeAtStore.toLocaleDateString('en-US'), 1);
  }

  minDate = firstAvailableDropoffDate || currentDate;
  maxDate = incrementDate(minDate, 30);

  return {
    ...BASE_OPTS,
    minDate,
    maxDate
  };
};

const initFlatpickr = (storeId, storeHours, firstAvailableDropoffDate) => {
  const closingTime = helper.getDatesClosingTime(storeHours, moment().format('MM/DD/YYYY'));
  const closingHour = helper.getHourFromString(closingTime);
  return getOptions(storeId, closingHour, firstAvailableDropoffDate);
};

const initDeliveryDropoffFlatpickr = (dateOptions) => {
  return {
    ...BASE_OPTS,
    minDate: moment().format('MM/DD/YYYY'),
    enable: dateOptions
  };
};

const initDeliveryPickupFlatpickr = (date = null) => {
  return {
    ...BASE_OPTS,
    minDate: date ? moment(date).add(1, 'day').format('MM/DD/YYYY') : moment().add(1, 'day').format('MM/DD/YYYY')
  };
};

export {
  initDeliveryDropoffFlatpickr,
  initDeliveryPickupFlatpickr,
  convertToLatestReservationHour,
  getOptions,
  incrementDate,
  initFlatpickr,
  DATE_FORMAT
};
